import ActionTypes from '../constants';

const initialState = {
    states: {},
    state: {},
    newState: {}
    // loading: false,
};

const stateReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETSTATESUCCESS:
            return {
                ...state,
                states: action.payload,
            }
        case ActionTypes.GETSTATEBYIDSUCCESS:
            return {
                ...state,
                state: action.payload,
            }
        case ActionTypes.SAVESTATESUCCESS:
            
            return {
                ...state,
                newState: action.payload,
            }
        default:
            return state;
    }
}

export default stateReducer;